"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumberToDollars = exports.formatTierLabels = exports.formatCreditLabel = exports.formatTermMonths = exports.formatDealerFees = exports.formatApr = void 0;
var dr_common_utils_1 = require("@makemydeal/dr-common-utils");
function formatApr(value) {
    return "".concat(value, "% APR");
}
exports.formatApr = formatApr;
function formatDealerFees(dealerFee) {
    if (!dealerFee || !dr_common_utils_1.formatUtils.isValidDollarAmount(dealerFee)) {
        return null;
    }
    return dr_common_utils_1.formatUtils.formatDollars(dealerFee);
}
exports.formatDealerFees = formatDealerFees;
function formatTermMonths(value, addSlash) {
    if (addSlash === void 0) { addSlash = false; }
    if (value) {
        return "".concat(value).concat(addSlash ? '/' : ' ', "mo");
    }
    else {
        return null;
    }
}
exports.formatTermMonths = formatTermMonths;
function formatCreditLabel(name, lowScore, highScore) {
    if (name) {
        return name === 'Below' ? "".concat(highScore) : "(".concat(lowScore, "-").concat(highScore, ")");
    }
    else {
        return null;
    }
}
exports.formatCreditLabel = formatCreditLabel;
function formatTierLabels(name) {
    return name.replace(/poor/i, 'Rebuilding');
}
exports.formatTierLabels = formatTierLabels;
var formatNumberToDollars = function (input) {
    if (typeof input === 'undefined' || input === null) {
        return;
    }
    if (dr_common_utils_1.formatUtils.isValidNumber(input)) {
        return dr_common_utils_1.formatUtils.formatDollars(input);
    }
    return input;
};
exports.formatNumberToDollars = formatNumberToDollars;
